import { LuBookOpen, LuNetwork, LuTvMinimal, LuUserRound } from "react-icons/lu";
import { LuClapperboard } from "react-icons/lu";
import { LuGamepad2 } from "react-icons/lu";
import { Vertical } from "../types/verticalTypes";

const AnimeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 54.279 54.279"
    fill="none"
    stroke="currentColor"
    strokeWidth={4}
    {...props}
  >
    <path
      d="m14.18 35.229 2.2-13.666 7.528 3.344 2.019-7.79 6.81 6.296 5.817-5.114 5.745 17.682"
      transform="translate(-3.282 -1.77)"
    />
    <path
      d="M52.608-27.557A23.538 23.538 0 0 1 40.84-7.173a23.538 23.538 0 0 1-23.538 0A23.538 23.538 0 0 1 5.532-27.557"
      transform="matrix(1 0 0 -1 -3.282 -1.77)"
    />
    <path
      d="M13.752 33.99S22.14 49.126 26.83 49.126h4.79c4.657 0 12.814-15.017 12.814-15.017"
      transform="translate(-3.282 -1.77)"
    />
    <path
      d="m5.44 27.068 3.324 19.757 3.459-2.823 2.352 6.947 5.12-8.491M52.613 27.225l-3.324 19.757-3.459-2.823-2.352 6.947-5.12-8.49"
      transform="translate(-3.282 -1.77)"
    />
  </svg>
);

const verticalLabelMap = {
  [Vertical.Movies]: "Movies",
  [Vertical.Series]: "Series",
  [Vertical.Games]: "Video Games",
  [Vertical.Books]: "Books",
  [Vertical.Franchises]: "Franchises",
  [Vertical.Talent]: "Talent",
  [Vertical.Anime]: "Anime",
  [Vertical.Manga]: "Manga",
};

const verticalColorMap = {
  [Vertical.Movies]: {
    border: "border-red-600 dark:border-red-400",
    text: "text-red-600 dark:text-red-400",
  },
  [Vertical.Series]: {
    border: "border-green-600 dark:border-green-400",
    text: "text-green-600 dark:text-green-400",
  },
  [Vertical.Games]: {
    border: "border-blue-600 dark:border-blue-400",
    text: "text-blue-600 dark:text-blue-400",
  },
  [Vertical.Books]: {
    border: "border-purple-600 dark:border-purple-400",
    text: "text-purple-600 dark:text-purple-400",
  },
  [Vertical.Franchises]: {
    border: "border-orange-600 dark:border-orange-400",
    text: "text-orange-600 dark:text-orange-400",
  },
  [Vertical.Talent]: {
    border: "border-yellow-600 dark:border-yellow-400",
    text: "text-yellow-600 dark:text-yellow-400",
  },
  [Vertical.Anime]: {
    border: "border-pink-600 dark:border-pink-400",
    text: "text-pink-600 dark:text-pink-400",
  },
  [Vertical.Manga]: {
    border: "border-gray-600 dark:border-gray-400",
    text: "text-gray-600 dark:text-gray-400",
  },
  default: {
    border: "",
    text: "",
  },
};



export const VerticalIcon = ({ vertical, titleCount=null, useColors=false, ...props }) => {
  if (!vertical) return null;
  const colorVertical = useColors ? vertical : "default";
  return (
    <span className={`inline-flex items-center gap-1 ${verticalColorMap[colorVertical]?.text} ${props.className}`} title={(titleCount ? `${titleCount} ` : "") + verticalLabelMap[vertical]} {...props}>
      {vertical === Vertical.Movies && <LuClapperboard className={props.className ?? ""} />}
      {vertical === Vertical.Series && <LuTvMinimal className={props.className ?? ""} />}
      {vertical === Vertical.Games && <LuGamepad2 className={props.className ?? ""} />}
      {vertical === Vertical.Franchises && <LuNetwork className={props.className ?? ""} />}
      {vertical === Vertical.Books && <LuBookOpen className={props.className ?? ""} />}
      {vertical === Vertical.Talent && <LuUserRound className={props.className ?? ""} />}
      {vertical === Vertical.Anime && <AnimeIcon className={props.className ?? ""} />}
      {vertical === Vertical.Manga && <LuBookOpen className={props.className ?? ""} />}
      {(titleCount != null) && <span className="text-sm">{titleCount}</span>}
    </span>
  );
};

export const VerticalIconBadge = ({ vertical, useColors=false, ...props }) => {
  if (!vertical) return null;
  const colorVertical = useColors ? vertical : "default";
  return (
    <span className={`border ${verticalColorMap[colorVertical].border} px-2 py-0.5 rounded-full ${verticalColorMap[colorVertical].text} inline-flex items-center`}>
      <VerticalIcon vertical={vertical} {...props} />
    </span>
  );
}